import { api } from "./api";
import { getConsent, visitorInfo } from "./consent";

let config = null;
const loaded = { gtm: false, ga: false, pixel: false };

const addScript = (src) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

const utm = () => {
  const p = new URLSearchParams(window.location.search);
  const saved = JSON.parse(sessionStorage.getItem("mhm-utm") || "null");
  if (saved) return saved;
  const v = { utm_source: p.get("utm_source") || "", utm_medium: p.get("utm_medium") || "", utm_campaign: p.get("utm_campaign") || "", referrer: document.referrer || "" };
  sessionStorage.setItem("mhm-utm", JSON.stringify(v));
  return v;
};

export const trafficSource = () => utm().utm_source || utm().referrer || "";

const applyConsent = () => {
  const c = getConsent();
  if (!config || !c) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  window.gtag("consent", "update", {
    analytics_storage: c.analytics ? "granted" : "denied",
    ad_storage: c.marketing ? "granted" : "denied",
    ad_user_data: c.marketing ? "granted" : "denied",
    ad_personalization: c.marketing ? "granted" : "denied",
  });
  if (c.analytics && config.gtm_id && !loaded.gtm) {
    loaded.gtm = true;
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    addScript(`https://www.googletagmanager.com/gtm.js?id=${config.gtm_id}`);
  }
  if (c.analytics && config.ga4_id && !loaded.ga) {
    loaded.ga = true;
    addScript(`https://www.googletagmanager.com/gtag/js?id=${config.ga4_id}`);
    window.gtag("js", new Date());
    window.gtag("config", config.ga4_id, { send_page_view: false });
  }
  if (c.marketing && config.meta_pixel_id && !loaded.pixel) {
    loaded.pixel = true;
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", config.meta_pixel_id);
  }
};

export const initTracking = async () => {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  window.gtag("consent", "default", { analytics_storage: "denied", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" });
  try {
    const { data } = await api.get("/public-config");
    config = data ?? {};
  } catch {
    config = {};
  }
  applyConsent();
  window.addEventListener("mhm-consent", applyConsent);
};

const send = (event, extra = {}) => {
  const v = visitorInfo();
  if (!v) return;
  const u = utm();
  api.post("/track", { ...v, ...u, event, ...extra }).catch(() => {});
};

export const trackPage = (path) => {
  send("pageview", { path });
  const c = getConsent();
  if (c?.analytics && config?.ga4_id && window.gtag) window.gtag("event", "page_view", { page_path: path, page_location: window.location.href });
  if (c?.marketing && window.fbq) window.fbq("track", "PageView");
};

export const trackProduct = (name) => {
  send("product_view", { product: name, path: window.location.pathname });
  const c = getConsent();
  if (c?.analytics && window.gtag) window.gtag("event", "view_item", { items: [{ item_name: name }] });
  if (c?.marketing && window.fbq) window.fbq("track", "ViewContent", { content_name: name });
};

export const trackHeartbeat = (seconds) => send("heartbeat", { seconds });

export const trackLead = (type, eventId) => {
  const c = getConsent();
  if (c?.analytics && window.gtag) window.gtag("event", "generate_lead", { form_type: type });
  if (c?.marketing && window.fbq) window.fbq("track", "Lead", { content_category: type }, { eventID: eventId });
};
